module.exports = __webpack_public_path__ + "static/media/sep.83b15cfb.jpg";